import { Box, Icon, IconButton, Logo } from '@betterment/samba-react';
import { css } from '@betterment/samba-styled-system/css';
import { SambaAutoLink } from '@betterment/shared-components';

import { urlBuilder } from '../../urlBuilder';

export interface NavHeaderProps {
  hasLogo: boolean;
  onHamburgerClick: () => void;
  isSidebarOpen: boolean;
}

export default function NavHeader({ hasLogo, onHamburgerClick, isSidebarOpen }: NavHeaderProps) {
  return (
    <header
      className={css({
        alignItems: 'baseline',
        width: '100%',
        gridTemplateColumns: 'auto 1fr auto',
        position: 'sticky',
        top: 0,
        height: '56px',
        backgroundColor: 'background.surface',
        color: 'primitives.black',
        display: {
          base: 'grid',
          xl: 'none',
        },
      })}
    >
      <IconButton
        css={{
          cursor: 'pointer',
          backgroundColor: 'transparent',
          color: 'icon',
          padding: 'space.200',
          margin: 0,
        }}
        onClick={onHamburgerClick}
        label="Open navigation menu"
        name="Hamburger"
        aria-controls="navigation-sidebar"
        aria-expanded={isSidebarOpen}
      />
      {hasLogo && (
        <Box asChild={true} css={{ display: 'grid' }}>
          <SambaAutoLink aria-label="Return to Betterment Home Page" to={urlBuilder.appHome.absolute()}>
            <Logo type="symbol" css={{ height: 'icon.small' }} />
          </SambaAutoLink>
        </Box>
      )}
      <SambaAutoLink
        aria-label="New transfer"
        css={{ color: 'icon', padding: 'space.200', gridColumnStart: 3 }}
        to={urlBuilder.appTransfersNewTransfer.absolute()}
      >
        <Icon name="Transfer" size="small" />
      </SambaAutoLink>
    </header>
  );
}
